import React, {Component} from 'react';
import {request} from "../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../helper/helper";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import ExcelCustomizer from "./ExcelCustomizer";
import Alert from "react-s-alert";
import {VirtualHost} from "../constants";
import {Image} from '../common/Image';

class ExcelExporter extends Component {

	constructor(props) {
		super(props);
		window.excelExportComponent = this;

		this.state = {
			exportSelected: true,
			isCustomExportEnabled: true,
			buttonStyle: null,
			customizerModal: false,
			isAll: false,
			isDate: false,
			startDate: null,
			finishDate: null,
			filterMap: [],
			isArchive: (this.props.type !== 'outboxTransfer'   &&
						this.props.type !== 'inboxTransfer'    &&
						this.props.type !== 'despatchOutboxTransfer'   &&
						this.props.type !== 'despatchInboxTransfer'    &&
						this.props.type !== 'eVoucherTransfer' &&
						this.props.type !== 'eArchiveTransfer' &&
						this.props.type !== 'customer') ? 0 : '',
			sourceId: '',
			sourceTitle: '',
			destinationId: '',
			destinationTitle: '',
			responseCode: '',
			documentProfile: '',
			invoiceTypeCode: '',
			cancelled: '',
			noDocumentError: false,
			vknTckn: '',
			formattedName: '',
			givenName: '',
			familyName: '',
			parentCustomerId: "",
			customerName:"",
			city:'',
			subdivision:'',
			taxOffice:'',
			impersonateUserRoleId: {}
		};

		this.exportXls = this.exportXls.bind(this);
		this.prepareSheetName = this.prepareSheetName.bind(this);
		this.openCustomizerModal = this.openCustomizerModal.bind(this);
		this.closeCustomizerModal = this.closeCustomizerModal.bind(this);
		this.confirmCustomHeaders = this.confirmCustomHeaders.bind(this);
		this.clearCustomHeaders = this.clearCustomHeaders.bind(this);
		this.handleSelectAll = this.handleSelectAll.bind(this);
		this.onChangeDate = this.onChangeDate.bind(this);
		this.filterResults = this.filterResults.bind(this);
		this.resetConditions = this.resetConditions.bind(this);
		this.exportXlsAll = this.exportXlsAll.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);
		this.prepareProgrespaymentUrl = this.prepareProgrespaymentUrl.bind(this);
	}

	componentDidMount() {
		if (!this.props.customExport) {
			this.setState({isCustomExportEnabled: this.props.customExport});
		}
		this.setState({filterMap: new Map()});
		if (this.props.disableSelect) {
			this.setState({exportSelected: false});
		}
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.customHeaders && nextProps.customHeaders.length !== 0) {
			this.exportXls();
		}
	}

	resetConditions() {
		this.setState({
			isAll: false,
			isDate: false,
			startDate: null,
			finishDate: null,
			filterMap: [],
			isArchive: (
				this.props.type !== 'outboxTransfer' &&
				this.props.type !== 'inboxTransfer' &&
				this.props.type !== 'despatchOutboxTransfer'   &&
				this.props.type !== 'despatchInboxTransfer'    &&
				this.props.type !== 'eVoucherTransfer' &&
				this.props.type !== 'eArchiveTransfer') ? 0 : '',
			sourceId: '',
			sourceTitle: '',
			destinationId: '',
			destinationTitle: '',
			responseCode: '',
			documentProfile: '',
			invoiceTypeCode: '',
			cancelled: '',
			noDocumentError: false,
			vknTckn: '',
			formattedName: '',
			givenName: '',
			familyName: '',
			parentCustomerId:"",
			city:'',
			subdivision:'',
			taxOffice:'',

		})
	}

	arrangeDataSet(type) {
		let dataSet = {};
		let selection = this.props.selection;
		let content = this.props.content;
		let selectedContent = [];

		if (!(type === 'custom' || type.includes('progressPayment'))) {
			content.map(con => {
				selection.map(sel => {
					if (con.recordId === sel) {
						selectedContent.push(con)
					}
				})
			});

			dataSet.content = selectedContent;
		}

		if (!this.state.customHeaders) {
			dataSet.headers = this.props.defaultHeaders;
		} else {
			dataSet.headers = this.state.customHeaders;
		}

		dataSet.sheetName = this.props.sheetName;

		let queryPayload = {};

		if (this.state.isAll) {
			queryPayload.startDate = null;
			queryPayload.finishDate = null;
			queryPayload.completeFetch = true;
		} else {
			queryPayload.startDate = deepCopyObject(this.state.startDate);
			queryPayload.finishDate = deepCopyObject(this.state.finishDate);
			queryPayload.completeFetch = false;
		}

		if (this.props.docType) {
			if (this.props.docType === 'SERBESTMESLEKMAKBUZ') {
				queryPayload.docType = 'sVoucher';
			} else {
				queryPayload.docType = 'mVoucher';
			}
		}
		if(!type.includes('progressPayment') && !this.props.type.includes('belgeIn')) {
			let filterMap = {};
			filterMap.isArchive = this.state.isArchive;
			filterMap.sourceId = this.state.sourceId;
			filterMap.sourceTitle = this.state.sourceTitle;
			filterMap.destinationId = this.state.destinationId;
			filterMap.destinationTitle = this.state.destinationTitle;
			filterMap.responseCode = this.state.responseCode;
			filterMap.documentProfile = this.state.documentProfile;
			filterMap.invoiceTypeCode = this.state.invoiceTypeCode;
			filterMap.cancelled = this.state.cancelled;
			filterMap.vknTckn = this.state.vknTckn;
			filterMap.formattedName = this.state.formattedName;
			filterMap.givenName = this.state.givenName;
			filterMap.familyName = this.state.familyName;
			filterMap.city = this.state.city;
			filterMap.subdivision = this.state.subdivision;
			filterMap.taxOffice = this.state.taxOffice;

			queryPayload.filterMap = filterMap;

			if (this.props.type === 'outbox' || this.props.type === 'eArchive') {
				dataSet.stateCodeMap = this.props.stateCodes;
			}
		}else if(this.props.type.includes('belgeIn')){
			let filterMap = {};
			filterMap.title = this.state.title;
			filterMap.profileId = this.state.documentProfile;
			filterMap.documentTypeCode = this.state.invoiceTypeCode;
			filterMap.cancelStatus = this.state.cancelled;
			filterMap.vknTckn = this.state.vknTckn;

			queryPayload.filterMap = filterMap;
		}

		dataSet.xlsQueryPayload = queryPayload;
		dataSet.uuid = this.create_UUID();
		dataSet.year = this.props.year;
		dataSet.month = this.props.month;
		console.log("dataSet",dataSet)
		return dataSet;
	}


	filterResults(e, field) {
		this.setState({
			[field]: e.target ? e.target.value : e.value
		});
	}

	create_UUID() {
		let dt = new Date().getTime();
		let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			let r = (dt + Math.random() * 16) % 16 | 0;
			dt = Math.floor(dt / 16);
			return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
		});
		return uuid;
	}

	async prepareSheetName() {
		let selection = deepCopyObject(this.props.selection);
		let isAllDocumentsSelected = deepCopyObject(this.state.isAll);
		let payload = [];
		let sheetName = null;

		if ((selection && selection.length > 0) && !isAllDocumentsSelected) {
			if (selection.length === 1) {
				payload.push(selection[0]);
				payload.push(null);
			} else {
				payload.push(selection[0]);
				payload.push(selection[selection.length - 1]);
			}

			let self = this;
			let customSheetNameUrl = (self.props.year !== undefined) ? `${self.props.customSheetNameUrl}?year=${self.props.year}` : self.props.customSheetNameUrl;
			let params = {
				url: customSheetNameUrl,
				method: "post",
				data: payload
			};
			self.setState({manual: self.manual === true ? false : self.manual});
			await request(params).then(function (response) {
				let result = response.data;
				if (result[1] === null) {
					if(self.props.type === "belgeIn"){
						sheetName = self.props.sheetName + ' - ' + result[0].documentId + ' - ' + result[0].issueDate.replace("T"," - ");
					}
					else{
						sheetName = self.props.sheetName + '-' + result[0].documentId + ' - (' + result[0].documentIssueDate + ')';
					}
				} else {
					if(self.props.type === "belgeIn"){
						sheetName = self.props.sheetName + '-' + result[1].documentId + ' - ' + result[0].documentId + ' - (' +
							result[1].issueDate.replace("T"," - ") + ' - ' + result[0].issueDate.replace("T"," - ") + ')';
					}
					else{
						sheetName = self.props.sheetName + '-' + result[1].documentId + ' - ' + result[0].documentId + ' - (' +
							result[1].documentIssueDate + ' - ' + result[0].documentIssueDate + ')';
					}
				}
			}).catch(function (error) {
				showAxiosError(error);
			});
		}

		if (isAllDocumentsSelected) {
			sheetName = 'Tüm ' + this.props.sheetName
		}

		if (!isAllDocumentsSelected && (!selection || selection.length === 0)) {
			sheetName = '(' + deepCopyObject(this.state.startDate) + ')' + ' - ' + '(' + deepCopyObject(this.state.finishDate) + ')' + ' Aralığındaki Tüm ' +
				this.props.sheetName;
		}

		return sheetName;
	}

	prepareProgrespaymentUrl(){
		let self = this;
		let dateField= self.props.type==="progressPayment" ? "purchaseDate" : "updatedAt";
		let url=self.props.url + "/" + (self.state.parentCustomerId === "" || self.state.parentCustomerId === null ? -1 : self.state.parentCustomerId) + "?page=0&size=10000" ;
		if (self.state.startDate!==null && self.state.finishDate!==null)
			url = url +"&" + dateField + "=" + self.state.startDate +" 00:00:00&"+ dateField +"="+self.state.finishDate +" 23:59:59" ;
		if (self.state.vknTckn !== null && self.state.vknTckn !== "")
			url = url +"&customer.vknTckn="+ self.state.vknTckn;
		if (self.state.customerName !== null && self.state.customerName !== "")
			url = url +"&customer.customerName="+ self.state.customerName;

		return url;
	}

	async exportXls() {
        console.log("exportXls")

        this.setState({buttonStyle: 'fas fa-spinner fa-spin'});
		let self = this;
		let data = self.arrangeDataSet(this.props.type) ;
		let params = {
			url: (!(this.props.type.includes('progressPayment')))
				? self.props.url
				: self.prepareProgrespaymentUrl(),
			method: "post",
			responseType: 'arraybuffer',
			data: data,
		};
		console.log("params",params);
		self.setState({manual: self.manual === true ? false : self.manual});
		let download = !(this.props.type.includes('progressPayment')) ? await self.prepareSheetName() : this.props.sheetName;
		if (!download.endsWith(".xlsx")) {
			download += ".xlsx";
		}
		await request(params).then(function (response) {
			let blob = new Blob([response.data], {type: response.headers["content-type"]});
			let urlCreator = window.URL || window.webkitURL;
			let url = urlCreator.createObjectURL(blob);
			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			a.href = url;
			// a.download = self.props.sheetName + ".xls";
			a.download = download;
			a.click();
			self.setState({buttonStyle: null});
		}).catch(function (error) {
			self.setState({buttonStyle: null});
			showAxiosError(error);
		});
	}

	async exportCustomXls() {
		this.setState({buttonStyle: 'fas fa-spinner fa-spin'});
		let self = this;
		let data = self.arrangeDataSet('custom');
		let params = {
			url: self.props.url + (self.props.predications ? self.props.predications : ""), //TODO: self
			method: "post",
			data: data,
		};
		self.setState({manual: self.manual === true ? false : self.manual});
		await request(params).then(function (response) {
			self.setState({buttonStyle: null, noDocumentError: false});
		}).catch(function (error) {
			self.setState({buttonStyle: null, noDocumentError: true});
			showAxiosError(error);
		});
	}

	async exportXlsAll() {

		let self = this;
        this.setState({buttonStyle: 'fas fa-spinner fa-spin'});

		let dataSet = {};

		dataSet.headers = this.props.defaultHeaders;
		dataSet.sheetName = this.props.sheetName;

		if (self.props.type && self.props.type === 'faultyOutboxDenied'){
			dataSet.source = self.props.source;
		}

		let params = {
			url: self.props.url, //TODO: self
			method: "post",
			responseType: 'arraybuffer',
			data: dataSet,
		};
		self.setState({manual: self.manual === true ? false : self.manual});
		let download = self.props.sheetName + '_' + this.getCurrentLocalDate();
		await request(params).then(function (response) {
			let blob = new Blob([response.data], {type: response.headers["content-type"]});
			let urlCreator = window.URL || window.webkitURL;
			let url = urlCreator.createObjectURL(blob);
			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			a.href = url;
			// a.download = self.props.sheetName + ".xls";
			a.download = download;
			a.click();
			self.setState({buttonStyle: null, noDocumentError: false});
		}).catch(function (error) {
			self.setState({buttonStyle: null, noDocumentError: true});
			showAxiosError(error);
		});
	}

	getCurrentLocalDate() {
		let today = new Date();
		let dd = String(today.getDate()).padStart(2, '0');
		let mm = String(today.getMonth() + 1).padStart(2, '0');
		let yyyy = today.getFullYear();

		today = dd + '/' + mm + '/' + yyyy;
		return today;
	}

	openCustomizerModal() {
		this.setState({customizerModal: true, isAll: true});
	}

	closeCustomizerModal() {
		this.setState({
			customizerModal: false,
		}, () => this.resetConditions())
	}

	async confirmCustomHeaders(data) {
		let isAll = deepCopyObject(this.state.isAll);
		let startDate = deepCopyObject(this.state.startDate);
		let finishDate = deepCopyObject(this.state.finishDate);
		if (!isAll && (!startDate || !finishDate) && this.props.type !== 'customer') {
			Alert.error('Geçerli bir tarih aralığı giriniz', {
				html: true,
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			})
		} else {
			await this.setState({customHeaders: data, noDocumentError: false},
				() => !(this.props.type.includes('progressPayment')) ? this.exportCustomXls() : this.exportXls() );
			this.closeCustomizerModal();
			await this.sleep(2000);
			if (!this.state.noDocumentError && !(this.props.type.includes('progressPayment'))) {
				this.props.triggerDownloadRequestTooltip();

			}
		}
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	clearCustomHeaders() {
		this.setState({customHeaders: []})
	}

	handleSelectAll() {
		let isAll = !deepCopyObject(this.state.isAll);
		this.setState({
			isAll,
			startDate: null,
			finishDate: null
		})
	}

	onChangeDate(e, field) {
		console.log("onChangeDate",e, field);
		if (!(typeof e === "string")) {
			let date = e.clone().format("YYYY-MM-DD");
			if (field === 'startDate') {
				this.setState({
					startDate: date
				});
			} else {
				this.setState({
					finishDate: date
				})
			}
		}
	}

	onChangeSelect(e,field){
		console.log("e,field",e,field);
		this.setState({[field]:e.value});
	}

	clearSelection() {
		this.props.clearSelection();
	}

	render() {

		return (
			<div style={{display: '-webkit-box'}}>
				{(this.props.selection && this.state.exportSelected) &&
				<Button
						className={this.props.bgColor ? 'mini-button ' + this.props.bgColor : 'mini-button'}
						type="button"
						data-toggle="tooltip"
						data-placement="top"
						rel="tooltip" title="Excel'e Aktar"
						disabled={this.props.selection && (this.props.selection.length === 0 || this.props.btnDisabled)}
						onClick={this.exportXls}>
					{this.state.buttonStyle &&
					<i className={this.state.buttonStyle}/>}
					{!this.state.buttonStyle &&
					<i className="fas fa-file-excel"/>}
				</Button>}

				{(this.props.completeFetch && this.props.completeFetch && !this.props.longButton) &&
				<Button
						className={this.props.bgColor ? 'mini-button ' + this.props.bgColor : 'mini-button'}
						type="button"
						data-toggle="tooltip"
						data-placement="top"
						rel="tooltip" title="Excel'e Aktar"
						onClick={this.exportXlsAll}>
					{this.state.buttonStyle &&
					<i className={this.state.buttonStyle}/>}
					{!this.state.buttonStyle &&
					<i className="fas fa-file-excel"/>}
				</Button>}

				{(this.props.completeFetch && this.props.completeFetch) &&
					(this.props.longButton && this.props.longButton ) &&
				<button type="button" data-toggle="tooltip" data-placement="bottom"
					style={{
					background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
					padding: '10px 54px 10px 23px',
					float:'right'
				}}
					rel="tooltip" className="TekBtn kaydet btn-icon"
					disabled={this.props.loading}
					onClick={this.exportXlsAll}>Excel'e Aktar
					</button>
				}

				{this.state.isCustomExportEnabled  &&
				<Button style={{marginLeft: '3px'}}
						className={this.props.bgColor ? 'mini-button ' + this.props.bgColor : 'mini-button'}
						type="button"
						data-toggle="tooltip"
						data-placement="top"
						rel="tooltip" title= {"Düzenle ve Excel'e Aktar"}
						disabled={((["smart", "kolaysoft", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix)) && (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4))}
						onClick={() => this.openCustomizerModal()}>
					{this.state.buttonStyle &&
					<i className={this.state.buttonStyle}/>}
					{!this.state.buttonStyle &&
						<div style={{ position: 'relative' }}>
							<i style={{ fontSize: '16px' }} className="fas fa-file-excel" />
							<div style={{ width: '15px', position: 'absolute', left: '7px', top: '2px' }} className="simple-text logo-mini customize-icon" />
						</div>

					}
				</Button>
				}

				<Modal isOpen={this.state.customizerModal} size={this.props.type === 'customer' ? 'sm' : 'lg'}>
					<ModalHeader toggle={this.closeCustomizerModal}>{this.props.modalHeader ? this.props.modalHeader : 'Excel Özelleştir'}</ModalHeader>
					<ModalBody style={{padding: '20px 0 0 20px'}}>
						<ExcelCustomizer type={this.props.type}
										 confirmCustomHeaders={this.confirmCustomHeaders}
										 handleSelectAllDocuments={this.handleSelectAll}
										 isAll={this.state.isAll}
										 onChangeDate={this.onChangeDate}
										 startDate={this.state.startDate}
										 finishDate={this.state.finishDate}
										 filterResults={this.filterResults}
										 isArchive={this.state.isArchive}
										 sourceId={this.state.sourceId}
										 sourceTitle={this.state.sourceTitle}
										 destinationId={this.state.destinationId}
										 destinationTitle={this.state.destinationTitle}
										 responseCode={this.state.responseCode}
										 vknTckn={this.state.vknTckn}
										 formattedName={this.state.formattedName}
										 familyName={this.state.familyName}
										 givenName={this.state.givenName}
										 documentProfile={this.state.documentProfile}
										 invoiceTypeCode={this.state.invoiceTypeCode}
										 cancelled={this.state.cancelled}
										 distributors={this.props.distributors}
										 parentCustomerId={this.state.parentCustomerId}
						                 onChangeSelect={this.onChangeSelect}/>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}

export default ExcelExporter;